"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20 = void 0;
const abis_1 = require("../../abis");
const contract_base_1 = __importDefault(require("../contract-base"));
class ERC20 extends contract_base_1.default {
    constructor(connectionConfig, contractAddress, unit) {
        super(connectionConfig, contractAddress, abis_1.ERC20ABI);
        this.unit = unit;
    }
    setDecimal() {
        return __awaiter(this, void 0, void 0, function* () {
            let decimal = yield this.contract.methods.decimals().call();
            this.unit = +decimal.toString();
            return decimal;
        });
    }
    getDecimal() {
        return __awaiter(this, void 0, void 0, function* () {
            let decimal = yield this.setDecimal();
            return decimal;
        });
    }
    getSymbol() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.symbol().call();
        });
    }
    getName() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.name().call();
        });
    }
    getBalance(address) {
        return __awaiter(this, void 0, void 0, function* () {
            let balance = yield this.contract.methods.balanceOf(address || this.currentAccount).call();
            return balance;
        });
    }
    getApprovedBalanceForAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            let balance = yield this.contract.methods.allowance(this.currentAccount, address).call();
            return balance;
        });
    }
    approve(address, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contractSendMethod("approve", "0", [address, amount]);
        });
    }
    transfer(receiver, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contractSendMethod("transfer", "0", [receiver, amount]);
        });
    }
    transferAll(receiver) {
        return __awaiter(this, void 0, void 0, function* () {
            let balance = yield this.getBalance();
            return this.transfer(receiver, balance.toString());
        });
    }
}
exports.ERC20 = ERC20;
exports.default = ERC20;
//# sourceMappingURL=erc20-contract-interface.js.map